import moment from 'moment';
import { MSG_INVALID_END_DATE } from "../../../../utils/messages";

export const validateForm = (values) => {

    let errors = {};
    

    if (moment(values.RenewalModel.subscriptionEndDate).isBefore(moment(), "days")) {
        errors[`RenewalModel.subscriptionEndDate`] = MSG_INVALID_END_DATE;
    }

    
    return errors;

}